import styled from "styled-components";

export default function PrivacyPolicy() {
  return (
    <Wrapper>
      <Container className="container">
        <Header>
          <h1>Legal & Policy Centre</h1>
          <p>
            Review our policies governing privacy, data protection, and use of
            OnePayX services.
          </p>
        </Header>
        <Content>
          <Section>
            <h2>1. Introduction</h2>
            <p>
              OnePayX is committed to protecting the privacy, confidentiality,
              and security of personal data entrusted to us by our users,
              partners, merchants, and stakeholders. This Privacy Policy & Data
              Protection Notice (the “Policy”) explains how YOYA Technologies
              Limited, trading as OnePayX (“OnePayX”, “we”, “us”, or “our”),
              collects, uses, discloses, stores, and safeguards personal data.
            </p>
            <p>
              This Policy is developed in accordance with the Uganda Data
              Protection and Privacy Act, 2019, its Regulations, and guidance
              issued by the Personal Data Protection Office (PDPO).
            </p>
          </Section>

          <Section>
            <h2>2. Scope of This Policy</h2>
            <ul>
              <li>Individual users of OnePayX digital wallet services</li>
              <li>Merchants, agents, and business partners</li>
              <li>Institutions, SACCOs, NGOs, and government entities</li>
              <li>Visitors to OnePayX websites and digital channels</li>
            </ul>
          </Section>

          <Section>
            <h2>3. Categories of Personal Data Collected</h2>

            <h3>3.1 Personal Identification Data</h3>
            <ul>
              <li>Full name</li>
              <li>Mobile phone number</li>
              <li>National Identification Number (NIN)</li>
              <li>Date of birth</li>
              <li>Gender (where required)</li>
              <li>Business or institutional affiliation</li>
            </ul>

            <h3>3.2 Transaction and Wallet Activity Data</h3>
            <ul>
              <li>Wallet balances and transaction history</li>
              <li>Payment amounts and timestamps</li>
              <li>Merchant and biller details</li>
              <li>Settlement and reconciliation records</li>
            </ul>

            <h3>3.3 Device and Technical Data</h3>
            <ul>
              <li>Device identifiers</li>
              <li>IP addresses and access logs</li>
              <li>Browser and application usage data</li>
            </ul>

            <h3>3.4 Customer Support Data</h3>
            <ul>
              <li>Support tickets and communications</li>
              <li>Call recordings and chat transcripts</li>
              <li>Feedback and complaints</li>
            </ul>
          </Section>

          <Section>
            <h2>4. Lawful Basis & Purpose of Processing</h2>
            <p>
              OnePayX processes personal data only where there is a lawful basis
              under the Uganda Data Protection and Privacy Act, 2019.
            </p>
            <ul>
              <li>Service provision and platform operations</li>
              <li>Legal and regulatory compliance</li>
              <li>Security, fraud prevention, and risk management</li>
              <li>Customer support and service improvement</li>
            </ul>
          </Section>

          <Section>
            <h2>5. Data Sharing & Disclosure</h2>
            <p>
              OnePayX does not sell personal data. Data may be shared only with:
            </p>
            <ul>
              <li>Regulated banks and payment partners</li>
              <li>Mobile money operators</li>
              <li>Regulators, courts, and law enforcement agencies</li>
              <li>Auditors and professional advisors</li>
            </ul>
          </Section>

          <Section>
            <h2>6. Cross-Border Data Transfers</h2>
            <p>
              Where data is processed outside Uganda, OnePayX ensures compliance
              with Ugandan law and equivalent data protection safeguards.
            </p>
          </Section>

          <Section>
            <h2>7. Data Retention</h2>
            <p>
              Personal data is retained only as long as necessary for legal,
              regulatory, and operational purposes, after which it is securely
              deleted or anonymised.
            </p>
          </Section>

          <Section>
            <h2>8. Rights of Data Subjects</h2>
            <ul>
              <li>Access personal data</li>
              <li>Request correction</li>
              <li>Object to processing</li>
              <li>Request deletion (subject to legal limits)</li>
            </ul>
          </Section>

          <Section>
            <h2>9. Data Security Measures</h2>
            <ul>
              <li>Encryption at rest and in transit</li>
              <li>Role-based access control</li>
              <li>Audit logs and monitoring</li>
              <li>Incident response procedures</li>
            </ul>
          </Section>

          <Section>
            <h2>10. Changes to This Policy</h2>
            <p>
              OnePayX may update this Policy periodically. Material changes will
              be communicated through the platform.
            </p>
          </Section>
        </Content>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background: #f8fafc;
  padding: 20px;
`;

const Container = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 50px 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Section = styled.div`
  h2 {
    font-size: 1.5rem;
    color: #0f172a;
    margin-bottom: 15px;
  }

  h3 {
    font-size: 1.1rem;
    margin: 20px 0 10px;
    color: #334155;
  }

  p {
    color: #475569;
    line-height: 1.8;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;

    li {
      margin-bottom: 8px;
      color: #475569;
      line-height: 1.6;
    }
  }
`;

const Header = styled.div`
  text-align: center;

  h1 {
    font-size: 2.2rem;
    color: #0f172a;
    margin-bottom: 12px;
  }

  p {
    max-width: 700px;
    margin: 0 auto;
    color: #475569;
    line-height: 1.7;
  }
`;
